import axios, { InternalAxiosRequestConfig } from 'axios';
import clerk from '../clerk';

import { apiUrl } from '@/env';
import store from '@/store';
import { readUserLocale } from '@/store/main/getters';
import type { GetSamlConnectionsResponse } from '@/interfaces/api/general/saml';

const injectLocale = async (config: InternalAxiosRequestConfig) => {
  config.headers.set('locale', readUserLocale(store));
  return config;
};

const api = axios.create({
  baseURL: `${apiUrl}/api/v1`,
});

api.interceptors.request.use(injectLocale, (error) => Promise.reject(error));
api.interceptors.request.use(async (config) => {
  const token = await clerk.session?.getToken({ template: 'with_external_id' });
  const isLoggedIn = clerk.session?.status === 'active';
  if (!token || !isLoggedIn) {
    // Refresh the page to reinitialize auth
    // and redirect the user to the login page.
    sessionStorage.setItem(
      'loginState',
      JSON.stringify({ tokenInvalidated: true })
    );
    window.location.reload();
  }
  config.headers.set('Authorization', `Bearer ${token}`);

  return config;
});

export const getSamlConnections = (companyId: string) =>
  api.get<GetSamlConnectionsResponse>(
    `/companies/${companyId}/saml_connections`
  );
